import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

//Eventually, Systems should check with the API if there was a recently opened system to load, and redirect
//to said system if available.

export const Home = () => {
  const { t } = useTranslation();
  return (
    <>
      <h1>{t('WelcomeToVirtualEngineer')}</h1>
      <p>
        <Trans
          i18nKey="WelcomeActions"
          components={{
            systemLink: <a href={`${process.env.REACT_APP_LEGACY_DASHBOARD_SUMMARY_URL}`} />,
            browseLink: <a href={`${process.env.REACT_APP_LEGACY_BASE_HOST}/Test/Browse`} />,
          }}
        />
      </p>
    </>
  );
};
